(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6831],{

/***/ 9424:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/[slug]",
      function () {
        return __webpack_require__(95398);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* reexport safe */ _cinch_nx_landing_feature_policy_page__WEBPACK_IMPORTED_MODULE_0__.Sb; }
/* harmony export */ });
/* harmony import */ var _cinch_nx_landing_feature_policy_page__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41020);
var __N_SSG = true;



/***/ }),

/***/ 41020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sb": function() { return /* reexport */ landing_feature_policy_pages; }
});

// UNUSED EXPORTS: getPolicyPageContentData, getStaticPathsGenerator, getStaticPropsGenerator, policiesStaticPaths

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 287 modules
var shared_src = __webpack_require__(40405);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 118 modules
var ui_src = __webpack_require__(32014);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/clause-section/clause-section.module.css
var clause_section_module = __webpack_require__(10255);
var clause_section_module_default = /*#__PURE__*/__webpack_require__.n(clause_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/clause-section/clause-section.tsx






const ClauseSection = ({ title , body  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (clause_section_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                element: "h2",
                className: (clause_section_module_default()).title,
                fontSize: "h1",
                id: (0,util_src/* dashify */.P1)(title),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                block: body,
                components: storyblokComponents
            })
        ]
    });
/* harmony default export */ var clause_section = (ClauseSection);

// EXTERNAL MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/cookie-policy-section/cookie-policy-section.module.css
var cookie_policy_section_module = __webpack_require__(71538);
var cookie_policy_section_module_default = /*#__PURE__*/__webpack_require__.n(cookie_policy_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/cookie-policy-section/cookie-policy-section.tsx






const CookiePolicySection = ({ title , intro , content , buttonText , tableSection , deleteSection  })=>{
    const { setIsPreferencesModalOpen  } = (0,ui_src/* useCookieModalOpen */.LA)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (cookie_policy_section_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                element: "h2",
                className: (cookie_policy_section_module_default()).title,
                fontSize: "h1",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                classNames: {
                    body: "storyblokRichTextBody"
                },
                children: (0,shared_src/* renderWithResolver */.be)(intro)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                    type: "button",
                    name: buttonText,
                    value: buttonText,
                    onClick: ()=>setIsPreferencesModalOpen(true),
                    children: buttonText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                classNames: {
                    body: "storyblokRichTextBody"
                },
                children: (0,shared_src/* renderWithResolver */.be)(content)
            }),
            tableSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                block: tableSection,
                components: storyblokComponents
            }),
            deleteSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                block: deleteSection,
                components: storyblokComponents
            })
        ]
    });
};
/* harmony default export */ var cookie_policy_section = (CookiePolicySection);

// EXTERNAL MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/cookie-policy-table/cookie-policy-table.module.css
var cookie_policy_table_module = __webpack_require__(19984);
var cookie_policy_table_module_default = /*#__PURE__*/__webpack_require__.n(cookie_policy_table_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/cookie-policy-table/cookie-policy-table.tsx


const isThirdParty = (index, thirdPartyCol)=>index === 1 && thirdPartyCol.toLowerCase() === "3rd party";
const CookiePolicyTable = ({ table , dontShowTableHeader  })=>{
    const head = table.thead.filter((head, index)=>index !== 2);
    const body = table.tbody;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: (cookie_policy_table_module_default()).table,
        "data-testid": "cookie-policy-table",
        children: [
            !dontShowTableHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: head.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: heading.value
                        }, heading._uid))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: body.map((row, rowIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: row.body.filter((cell, index)=>index !== 2).map((cell, index)=>isThirdParty(index, `${row.body[3].value}`) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: row.body[2].value,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: cell.value
                                })
                            }, cell._uid) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: cell.value
                            }, cell._uid))
                    }, row._uid))
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/table-section/table-section.tsx




const TableSection = ({ heading , description , table , dontShowTableHeader  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* ContentSection */.IH, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: heading
                })
            }),
            description && (0,shared_src/* renderWithResolver */.be)(description),
            table && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiePolicyTable, {
                table: table,
                dontShowTableHeader: dontShowTableHeader
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/instructions-table/instructions-table.module.css
var instructions_table_module = __webpack_require__(39457);
var instructions_table_module_default = /*#__PURE__*/__webpack_require__.n(instructions_table_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/instructions-table/instructions-table.tsx




const InstructionsTable = ({ instructions  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
            className: (instructions_table_module_default()).table,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: instructions.map((step)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: step.browser
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: (0,shared_src/* renderWithResolver */.be)(step.steps)
                            })
                        ]
                    }, step._uid))
            })
        })
    });

// EXTERNAL MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/delete-cookies-section/delete-cookies-section.module.css
var delete_cookies_section_module = __webpack_require__(8610);
var delete_cookies_section_module_default = /*#__PURE__*/__webpack_require__.n(delete_cookies_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/delete-cookies-section/delete-cookies-section.tsx





const DeleteCookiesSection = ({ title , pcNote , pcInstructions , macNote , macInstructions  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (delete_cookies_section_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                element: "h2",
                className: (delete_cookies_section_module_default()).title,
                fontSize: "h1",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                children: pcNote && (0,shared_src/* renderWithResolver */.be)(pcNote)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstructionsTable, {
                instructions: pcInstructions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                children: macNote && (0,shared_src/* renderWithResolver */.be)(macNote)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstructionsTable, {
                instructions: macInstructions
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/components/index.ts





;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/data/storyblok-renderer-map.ts



const storyblokComponents = {
    ClauseSection: clause_section,
    CookiePolicySection: cookie_policy_section,
    TableSection: TableSection,
    DeleteCookiesSection: DeleteCookiesSection,
    RichTextSection: shared_src/* RichTextSection */.nT,
    FaqSection: shared_src/* FaqAccordion */.eo
};

// EXTERNAL MODULE: ../../../libs/landing/feature-policy-pages/src/lib/landing-feature-policy-pages.module.css
var landing_feature_policy_pages_module = __webpack_require__(46223);
var landing_feature_policy_pages_module_default = /*#__PURE__*/__webpack_require__.n(landing_feature_policy_pages_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/landing-feature-policy-pages.tsx










const shouldRenderTable = (table)=>{
    var ref, ref1, ref2;
    return (table === null || table === void 0 ? void 0 : table.fieldtype) === "table" && (table === null || table === void 0 ? void 0 : table.tbody.length) > 0 && ((ref1 = (ref = table.tbody) === null || ref === void 0 ? void 0 : ref[0].body) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.value) !== " ";
};
function PolicyPageFeature({ story , preview  }) {
    var ref, ref1, ref2;
    const typedStory = story;
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story: typedStory,
        enableBridge: preview
    });
    const typedContent = content;
    const SEO = typedContent === null || typedContent === void 0 ? void 0 : (ref = typedContent["SEO"]) === null || ref === void 0 ? void 0 : ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                fallbackTitle: (story === null || story === void 0 ? void 0 : story.slug) ? story === null || story === void 0 ? void 0 : story.slug : "Cinch Used Cars Article",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                className: {
                    inner: (landing_feature_policy_pages_module_default()).container
                },
                "data-testid": "feature-policy-page-wrapper",
                children: typedContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            element: "h1",
                            className: (landing_feature_policy_pages_module_default()).title,
                            fontSize: "h1",
                            children: typedContent.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                            classNames: {
                                body: "storyblokRichTextBody"
                            },
                            children: (0,shared_src/* renderWithResolver */.be)(typedContent.body, {
                                makeId: true
                            })
                        }),
                        typedContent.table && shouldRenderTable(typedContent.table) && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Table */.iA, {
                            ...typedContent.table
                        }),
                        typedContent.widestRangeClaimTable && shouldRenderTable((ref1 = typedContent.widestRangeClaimTable) === null || ref1 === void 0 ? void 0 : ref1.table) && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Table */.iA, {
                            ...(ref2 = typedContent.widestRangeClaimTable) === null || ref2 === void 0 ? void 0 : ref2.table
                        }),
                        typedContent.clauses && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: typedContent.clauses,
                            components: storyblokComponents
                        }),
                        typedContent.cookiePolicy && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: typedContent.cookiePolicy,
                            components: storyblokComponents
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var landing_feature_policy_pages = (PolicyPageFeature);

;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/data/content.ts

const getPolicyPageContentData = async (slug, preview = false)=>{
    const story = await getStoryBySlug(`policies/${slug}`, {
        version: preview ? "draft" : "published",
        cv: Date.now()
    });
    return story ?? undefined;
};

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/get-static-props.ts


function getStaticPropsGenerator(path) {
    return async ({ preview =false , params  })=>{
        try {
            const slug = path === "rangeclaim" ? `${path}` : `${path}/${params === null || params === void 0 ? void 0 : params.slug}`;
            const story = await getStoryBySlug(slug, {
                version: preview ? "draft" : "published"
            });
            if (!story) {
                throw new Error("No story found for this policy page");
            }
            setTag("page.name", slug);
            setTag("page.rendered", "ISR");
            setTag("page.revalidate-in", "60s");
            setTag("page.params", JSON.stringify({
                preview
            }, null, 2));
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            if (error instanceof Error || typeof error === "string") {
                tagError(error);
            }
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        showBorderRadius: true
                    }
                },
                revalidate: 60
            };
        }
    };
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/lib/get-static-paths.ts


function getStaticPathsGenerator(slug) {
    return async ()=>{
        try {
            const links = await getLinks(slug);
            const filteredLinks = Object.fromEntries(Object.entries(links).filter(([, link])=>!link.slug.includes(slug)));
            const paths = policiesStaticPaths({
                links: filteredLinks
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-policy-pages/src/index.ts







/***/ }),

/***/ 10255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"clause-section_container__a0uBP","title":"clause-section_title__8L66L"};

/***/ }),

/***/ 71538:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"cookie-policy-section_container__Vfogo","title":"cookie-policy-section_title__l15Yi"};

/***/ }),

/***/ 19984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"cookie-policy-table_table__Q_iBR","small":"cookie-policy-table_small__Ybnag"};

/***/ }),

/***/ 8610:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"delete-cookies-section_title__DzD9R"};

/***/ }),

/***/ 39457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"instructions-table_table__vKgIy","small":"instructions-table_small__4rsbf"};

/***/ }),

/***/ 46223:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"landing-feature-policy-pages_container__AO5_d","title":"landing-feature-policy-pages_title__RqK8H"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(9424); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);